module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.page) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__wrap"
  }, [_c('div', {
    staticClass: "modal__title"
  }, [_vm._v("\n        ส่ง e-card ให้ครอบครัว หรือเพื่อนของคุณ\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__content"
  }, [_c('a', {
    staticClass: "modal__close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times fa-lg"
  })]), _vm._v(" "), _c('send-email-form', {
    ref: "emailForm",
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal__footer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--inline btn--white",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("ยกเลิก")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--inline btn--purple",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("ส่งอีการ์ด")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab02e3e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareEmailPopup.vue
// module id = 1088
// module chunks = 1